import cn from "classnames"
import richText from "utilities/richText"

export default function AlertBanner({ blok }) {
  return (
    <aside className="px-8 pt-20 sm:pt-12 mb-12 mx-auto max-w-screen-xl relative">
      <h2
        className={cn("absolute left-1 top-2 sm:left-2 sm:top-2 bg-no-repeat bg-contain bg-center w-32 h-28", {
          "bg-pawprint text-white": blok.color_variation === "green-teal",
          "bg-pawprintWhite text-gray-dark": blok.color_variation === "white-green",
        })}
      >
        <span className="text-center absolute bottom-4 left-1/2 -translate-x-1/2 w-12 leading-4 text-s2">Hold up!</span>
      </h2>
      <div
        className={cn(
          "text-black pt-11 pb-6 px-4 sm:py-2 sm:pl-28 sm:pr-16 rounded-[20px] sm:ml-6 prose-p:text-s2 min-h-[60px] flex items-center",
          {
            "bg-green-sea": blok.color_variation === "green-teal",
            "bg-green-apple": blok.color_variation === "white-green",
          }
        )}
      >
        {richText(blok.content)}
      </div>
    </aside>
  )
}
